export default ["Men", "Women", "Kids", "Contact"];
